import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'
import AnimateHeight from 'react-animate-height'

export const Root = styled.div`
  ${tw`w-full`};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
`

export const HeaderButton = styled.button`
  ${tw`w-full flex justify-between items-center`};
  font-weight: 800;
`

export const BodyWrapper = styled(AnimateHeight)``

export const Body = styled.div`
  ${tw`border-b pt-4 sm:pt-2 pb-8 sm:pb-6`};
`

export const HeaderWrapper = styled.div`
  ${tw`border-b pb-4 sm:pb-2`};

  ${BodyWrapper} + & {
    ${tw`pt-4 sm:pt-2`};
  }
`

export const Caret = styled.div`
  ${tw`inline-flex items-center justify-center pr-2`};
  transition: background-color 0.2s;
`

export const CaretIcon = styled.div`
  transform: rotate(180deg);
  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  ${({ $isOpen }) => $isOpen && tw`rotate-0`}
  fill: #fff;
`
